import { useEffect, useRef, useState } from "react";
import { PrimaryLink } from "../components/Links";
import { ChevronDown, ChevronUp } from "../components/Icons";

export const categoriasYServicios = [
  {
    categoria: "Servicios domiciliarios",
    servicios: [
      "Aire acondicionado (service y colocación)",
      "Albañilería de interior",
      "Burletes",
      "Carpinteros",
      "Cerrajeros",
      "Destapaciones",
      "Electricidad",
      "Fumigadores",
      "Gas",
      "Herreros",
      "Jardineros",
      "Limpieza de alfombra y tapizados",
      "Limpieza de tanques de agua",
      "Lustrador de muebles",
      "Multirubro",
      "Parquetistas",
      "Persianas (service y colocación)",
      "Pintores de interior",
      "Plomería",
      "Service computadoras",
      "Service heladeras",
      "Service lavarropas",
      "Service microondas",
      "Service TV y video",
      "Telefonía (service)",
      "Tender",
      "Valvulistas",
    ],
    disclaimer:
      "Estos servicios cuentan con garantía técnica domiciliaria de 3 meses.",
  },
  {
    categoria: "Contactos útiles",
    servicios: [
      "Alquileres para fiestas",
      "Fletes y mudanzas",
      "Gestoría",
      "Limpieza de toldos",
      "Mecánica automotor",
      "Mensajería",
      "Pintura de exterior",
    ],
    disclaimer:
      "Te compartimos el contacto de profesionales y empresas de gran utilidad y vos coordinas directamente con ellos. Estos trabajos no cuentan con garantía de Soluciones Hogar.",
  },
];

const SolicitarTecnico = () => {
  const [service, setService] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <section className="relative min-h-screen bg-cover bg-center flex items-center justify-center bg-secondary/50">
        <div className="container px-6 py-24 mx-auto text-white text-center">
          <h1 className="mb-6 text-white">¿Qué servicio necesitas hoy?</h1>
          <div className="flex flex-col items-center gap-4">

            <div className="relative w-full max-w-xs" ref={dropdownRef}>
              <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex flex-row justify-between transition bg-white text-secondary border border-gray-300 px-4 py-3 rounded-md text-left truncate"
              >
                {service || "Selecciona un servicio"}
                {isOpen ? (
                  <ChevronUp className="w-5 h-5" />
                ) : (
                  <ChevronDown className="w-5 h-5" />
                )}
              </button>

              {isOpen && (
                <div className="absolute z-10 mt-1 w-full max-h-60 overflow-auto bg-white border border-gray-300 rounded-md shadow-lg text-left text-secondary">
                  {categoriasYServicios.map((categoria) => (
                    <div key={categoria.categoria}>
                      <div className="px-4 py-2 text-sm font-semibold text-gray-500 bg-gray-100">
                        {categoria.categoria}
                      </div>
                      {categoria.servicios.map((servicio) => (
                        <div
                          key={servicio}
                          className="pr-4 pl-6 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-200 whitespace-normal"
                          onClick={() => {
                            setService(servicio);
                            setIsOpen(false);
                          }}
                        >
                          {servicio}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <PrimaryLink
              target="__blank"
              href={`https://wa.me/5491150981730?text=Hola, necesito un servicio de ${service}`}
              className=""
            >
              Solicitar técnico
            </PrimaryLink>
          </div>

          <span className="block mt-4 text-sm text-gray-300 font-semibold">
            Solo válido para asociados
          </span>
        </div>
        <img
          className="absolute w-full h-full object-cover -z-20"
          src="/servicios-banner.webp"
          alt="tecnico "
        />
      </section>
      <section
        id="todos-los-servicios"
        className="container mx-auto px-4 pb-12 overflow-hidden pt-28"
      >
        <h2 className="text-center text-secondary mb-8">
          Todos nuestros servicios
        </h2>

        {categoriasYServicios.map((categoria, idx) => (
          <div key={idx} className="mb-10">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">
              {categoria.categoria}
            </h3>
            <div className="flex flex-row flex-wrap gap-2">
              {categoria.servicios.map((servicio, i) => (
                <div
                  key={i}
                  className="bg-white shadow-sm border border-gray-200 rounded-lg px-4 py-2 text-sm text-gray-700"
                >
                  {servicio}
                </div>
              ))}
            </div>
            {categoria.disclaimer && (
              <p className="text-sm text-gray-500 pt-4 italic">
                {categoria.disclaimer}
              </p>
            )}
          </div>
        ))}
      </section>
    </>
  );
};

export default SolicitarTecnico;
